import { DEVELOPMENT, PRODUCTION, STAGING } from "../config/constant";
import { baseDomains } from "../config/subDomain";

export const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (baseDomains[PRODUCTION].includes(hostname)) {
    return PRODUCTION;
  }

  if (baseDomains[STAGING].includes(hostname)) {
    return STAGING;
  }

  return DEVELOPMENT;
};
export const isStaging = () => getEnvironment() === STAGING;
export const isProduction = () => getEnvironment() === PRODUCTION;
export const isDevelopment = () => getEnvironment() === DEVELOPMENT;

export const getIsSegregatedFromEnv = () => {
  return process.env.REACT_APP_IS_SEGREGATED === "true";
};

export const getMunicipalityFromUrl = () => {
  const segregatedFromEnv = getIsSegregatedFromEnv();
  let currentUrl = window.location.hostname;

  if (segregatedFromEnv) {
    const parts = currentUrl.split(".");
    if (parts.length > 2 && parts[0] !== "www") {
      return parts[0];
    }

    return process.env.REACT_APP_MUNICIPALITY_KEY;
  } else {
    return window.location.pathname.replace(/^\/([^/]*).*$/g, "$1");
  }
};

export const isSegregated = (url = window.location.hostname) => {
  return getIsSegregatedFromEnv();
};



// WEBPACK FOOTER //
// ./src/utils/core-helpers.js